export default __webpack_public_path__ + "static/media/ambulance.3eccc3f9.png";